import en from './locales/en';
import ptBR from './locales/pt-BR';

export { en, ptBR };
